/**
 * 管家（企业）信息本地存储及页面标题前缀处理
 */
export const MGR_INFO_KEYS = {
    IS_SHOW: "is_show_mgr",
    NAME: "mgr_name",
    LOGO: "mgr_logo",
};

// 首页使用的默认应用名，开启管家信息时直接用 mgr_name 替换
export const BASE_APP_NAME = "圆租";

export const isShowMgr = () => {
    const value = localStorage.getItem(MGR_INFO_KEYS.IS_SHOW);
    return value === "true" || value === "1";
};

export const getMgrName = () => localStorage.getItem(MGR_INFO_KEYS.NAME) || "";

export const getMgrLogo = () => localStorage.getItem(MGR_INFO_KEYS.LOGO) || "";

export const getMgrTitlePrefix = () => {
    if (!isShowMgr()) return "";
    const mgrName = getMgrName();
    return mgrName ? `${mgrName}-` : "";
};

export const getMgrTitle = (title) => {
    if (!title) return title || "";
    const prefix = getMgrTitlePrefix();
    if (!prefix) return title;
    // 首页直接用管家名称替换默认应用名，不再加 "mgr_name-" 前缀
    if (title === BASE_APP_NAME) return getMgrName() || title;
    if (title.indexOf(prefix) === 0) return title;
    return `${prefix}${title}`;
};

export const applyMgrTitle = () => {
    document.title = getMgrTitle(document.title);
};

const MGR_FAVICON_ID = "mgr-favicon";

/**
 * 有管家 logo 时将其设置为浏览器标签页图标
 */
export const applyMgrFavicon = () => {
    const logo = isShowMgr() ? getMgrLogo() : "";
    let link = document.getElementById(MGR_FAVICON_ID);
    if (!logo) {
        if (link && link.parentNode) link.parentNode.removeChild(link);
        return;
    }
    if (!link) {
        link = document.createElement("link");
        link.id = MGR_FAVICON_ID;
        link.rel = "icon";
        document.head.appendChild(link);
    }
    link.href = logo;
};

const stripMgrTitlePrefix = () => {
    const prefix = getMgrTitlePrefix();
    if (prefix && document.title.indexOf(prefix) === 0) {
        document.title = document.title.slice(prefix.length);
    } else if (
        isShowMgr() &&
        getMgrName() &&
        document.title === getMgrName()
    ) {
        // 首页标题直接是管家名称时，恢复默认应用名
        document.title = BASE_APP_NAME;
    }
};

/**
 * 保存 user/info 返回的管家信息
 * is_show_mgr 为 true 时写入本地存储并立即更新当前页面标题，
 * 否则清空本地已缓存的管家信息
 */
export const saveMgrInfo = (info = {}) => {
    const show =
        info.is_show_mgr === true ||
        info.is_show_mgr === "true" ||
        info.is_show_mgr === 1;
    if (!show) {
        clearMgrInfo();
        return;
    }
    stripMgrTitlePrefix();
    localStorage.setItem(MGR_INFO_KEYS.IS_SHOW, "true");
    localStorage.setItem(MGR_INFO_KEYS.NAME, info.mgr_name || "");
    localStorage.setItem(MGR_INFO_KEYS.LOGO, info.mgr_logo || "");
    applyMgrTitle();
    applyMgrFavicon();
};

export const clearMgrInfo = () => {
    stripMgrTitlePrefix();
    Object.keys(MGR_INFO_KEYS).forEach((key) => {
        localStorage.removeItem(MGR_INFO_KEYS[key]);
    });
    applyMgrFavicon();
};



// WEBPACK FOOTER //
// ./src/utils/mgr.js